import React from "react";
import { useEffect } from "react";
import {
  Box,
  Divider,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import playerImg from "../../utils/images/player.png";
import FuningoStrip from "./images/funingo-strip.png";
import moscot from "../../assets/mascot.png";
import FacebookIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import MapIcon from "@mui/icons-material/Map";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import PolicyIcon from "@mui/icons-material/Policy";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import RefundIcon from "@mui/icons-material/Restore";

import "./styles.scss";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import FreebiesMascot from "../freebies-modal/freebies-mascot";
import { LocationCity } from "@mui/icons-material";

const Footer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();

  return (
    <Grid
      className="footer"
      m={{ xs: "70px 20px", lg: "70px 220px" }}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
    >
      {/* section 1 - Restructured Layout */}
      <Grid
        className="footer-top-box"
        display={{ xs: "flex" }}
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={{ xs: "center", md: "flex-start" }}
        justifyContent={"space-between"}
        width={"100%"}
        gap={{ xs: 4, md: 0 }}
      >
        {/* Left - Contact Information */}
        <Grid
          className="container-footer"
          display={"flex"}
          flexDirection={"column"}
          textAlign={{ xs: "center", md: "left" }}
          sx={{
            order: { xs: 2, md: 1 },
            flex: { md: "0 0 auto" },
          }}
        >
          <Typography
            className="heading"
            sx={{
              fontSize: { xs: "1.2rem", md: "1.4rem" },
              fontWeight: "700",
              mb: 2,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Contact Us
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            <Box
              component="a"
              href="tel:+917879333731"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "center", md: "flex-start" },
                gap: 1,
                textDecoration: "none",
                padding: "8px 12px",
                borderRadius: "8px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(102, 126, 234, 0.1)",
                  transform: { xs: "translateY(-2px)", md: "translateX(5px)" },
                },
              }}
            >
              <PhoneIcon
                sx={{
                  fontSize: "18px",
                  color: "#667eea",
                  transition: "transform 0.3s ease",
                  "&:hover": { transform: "rotate(15deg)" },
                }}
              />
              <Typography
                sx={{
                  fontSize: { xs: "0.95rem", md: "1rem" },
                  color: "#333",
                  fontWeight: "500",
                }}
              >
                +91-9202340761
              </Typography>
            </Box>

            <Box
              component="a"
              href="tel:+919425850422"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "center", md: "flex-start" },
                gap: 1,
                textDecoration: "none",
                padding: "8px 12px",
                borderRadius: "8px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(102, 126, 234, 0.1)",
                  transform: { xs: "translateY(-2px)", md: "translateX(5px)" },
                },
              }}
            >
              <PhoneIcon
                sx={{
                  fontSize: "18px",
                  color: "#667eea",
                  transition: "transform 0.3s ease",
                  "&:hover": { transform: "rotate(15deg)" },
                }}
              />
              <Typography
                sx={{
                  fontSize: { xs: "0.95rem", md: "1rem" },
                  color: "#333",
                  fontWeight: "500",
                }}
              >
                +91-9425850422
              </Typography>
            </Box>

            <Box
              component="a"
              target="blank"
              href="https://maps.app.goo.gl/VL4sZnGMAWcG5nPd9"
              sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: { xs: "center", md: "flex-start" },
                gap: 1,
                textDecoration: "none",
                padding: "12px",
                borderRadius: "12px",
                border: "1px solid rgba(102, 126, 234, 0.2)",
                transition: "all 0.3s ease",
                mt: 1,
                "&:hover": {
                  backgroundColor: "rgba(102, 126, 234, 0.05)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 20px rgba(102, 126, 234, 0.15)",
                  borderColor: "rgba(102, 126, 234, 0.4)",
                },
              }}
            >
              <LocationOnIcon
                sx={{
                  fontSize: "20px",
                  color: "#667eea",
                  mt: "2px",
                  transition: "all 0.3s ease",
                }}
              />
              <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
                <Typography
                  sx={{
                    fontSize: { xs: "0.9rem", md: "0.95rem" },
                    lineHeight: 1.5,
                    color: "#333",
                    fontWeight: "500",
                  }}
                >
                  Funingo Adventure Park, 83/2/2,
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "0.9rem", md: "0.95rem" },
                    lineHeight: 1.5,
                    color: "#666",
                    fontWeight: "400",
                  }}
                >
                  Manegaon, Nagpur Road, Jabalpur
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* Center - Mascot Image */}
        <Grid
          className="container-footer"
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          sx={{
            order: { xs: 1, md: 2 },
            flex: { md: "0 0 auto" },
            mx: { md: 4 },
          }}
        >
          <Box
            component="img"
            src={moscot}
            alt="Funingo Mascot"
            sx={{
              width: { xs: "140px", md: "180px" },
              height: { xs: "10rem", md: "15rem" },
              objectFit: "contain",
              filter: "drop-shadow(0 4px 20px rgba(0, 0, 0, 0.15))",
              transition: "all 0.3s ease",
              cursor: "pointer",
              "&:hover": {
                transform: "scale(1.05) rotate(5deg)",
                filter: "drop-shadow(0 6px 30px rgba(0, 0, 0, 0.2))",
              },
            }}
          />
        </Grid>

        {/* Right - Policies */}
        <Grid
          className="container-footer"
          display={"flex"}
          flexDirection={"column"}
          textAlign={{ xs: "center", md: "right" }}
          sx={{
            order: { xs: 3, md: 3 },
            flex: { md: "0 0 auto" },
          }}
        >
          <Typography
            className="heading"
            sx={{
              fontSize: { xs: "1.2rem", md: "1.4rem" },
              fontWeight: "700",
              mb: 2,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Policies
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            <Box
              component="a"
              href="/policies"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                textDecoration: "none",
                padding: "8px 12px",
                borderRadius: "8px",
                transition: "all 0.3s ease",
                justifyContent: { xs: "center", md: "flex-end" },
                "&:hover": {
                  backgroundColor: "rgba(102, 126, 234, 0.1)",
                  transform: "translateX(-5px)",
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "0.95rem", md: "1rem" },
                  color: "#333",
                  fontWeight: "500",
                  order: { xs: 2, md: 1 },
                }}
              >
                Terms and Conditions
              </Typography>
              <PolicyIcon
                sx={{
                  fontSize: "18px",
                  color: "#667eea",
                  order: { xs: 1, md: 2 },
                  transition: "transform 0.3s ease",
                  "&:hover": { transform: "rotate(15deg)" },
                }}
              />
            </Box>

            <Box
              component={HashLink}
              to="/policies/#privacy-policy"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                textDecoration: "none",
                padding: "8px 12px",
                borderRadius: "8px",
                transition: "all 0.3s ease",
                justifyContent: { xs: "center", md: "flex-end" },
                "&:hover": {
                  backgroundColor: "rgba(102, 126, 234, 0.1)",
                  transform: "translateX(-5px)",
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "0.95rem", md: "1rem" },
                  color: "#333",
                  fontWeight: "500",
                  order: { xs: 2, md: 1 },
                }}
              >
                Privacy Policy
              </Typography>
              <PrivacyTipIcon
                sx={{
                  fontSize: "18px",
                  color: "#667eea",
                  order: { xs: 1, md: 2 },
                  transition: "transform 0.3s ease",
                  "&:hover": { transform: "rotate(15deg)" },
                }}
              />
            </Box>

            <Box
              component={HashLink}
              to="/policies/#refund-policy"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                textDecoration: "none",
                padding: "8px 12px",
                borderRadius: "8px",
                transition: "all 0.3s ease",
                justifyContent: { xs: "center", md: "flex-end" },
                "&:hover": {
                  backgroundColor: "rgba(102, 126, 234, 0.1)",
                  transform: "translateX(-5px)",
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "0.95rem", md: "1rem" },
                  color: "#333",
                  fontWeight: "500",
                  order: { xs: 2, md: 1 },
                }}
              >
                Refund Policy
              </Typography>
              <RefundIcon
                sx={{
                  fontSize: "18px",
                  color: "#667eea",
                  order: { xs: 1, md: 2 },
                  transition: "transform 0.3s ease",
                  "&:hover": { transform: "rotate(180deg)" },
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* Modern Funingo Strip with enhanced styling */}
      <Box
        component={"img"}
        src={FuningoStrip}
        sx={{
          width: { xs: "100vw", sm: "100%" },
          height: { md: "auto" },
          mt: "40px",
          filter: "drop-shadow(0 8px 32px rgba(0, 0, 0, 0.1))",
          borderRadius: "12px",
          transition: "all 0.3s ease",
          cursor: "pointer",
          "&:hover": {
            transform: "scale(1.02)",
            filter: "drop-shadow(0 12px 48px rgba(0, 0, 0, 0.15))",
          },
        }}
      />

      <Divider
        sx={{
          borderWidth: "1px",
          width: "100%",
          mt: "30px",
          background:
            "linear-gradient(90deg, transparent, rgba(0,0,0,0.1), transparent)",
          border: "none",
          height: "1px",
        }}
      />

      <Grid
        display={"flex"}
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={"center"}
        justifyContent={"center"}
        py={{ xs: "20px", md: "25px" }}
        px={{ xs: "20px", md: "30px" }}
        gap={{ xs: 2, md: 0 }}
        sx={{
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)",
          borderRadius: "20px",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255,255,255,0.2)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          mt: "30px",
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
          },
        }}
      >
        <Typography
          sx={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: "700",
            fontSize: { xs: "16px", md: "18px" },
            mr: { xs: 0, md: "15px" },
            mb: { xs: "5px", md: 0 },
          }}
        >
          Follow Us:
        </Typography>

        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={{ xs: "8px", md: "6px" }}
          flexWrap="wrap"
        >
          <IconButton
            sx={{
              background: "linear-gradient(135deg, #1877f2 0%, #42a5f5 100%)",
              color: "white",
              width: { xs: "40px", md: "48px" },
              height: { xs: "40px", md: "48px" },
              transition: "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
              boxShadow: "0 4px 15px rgba(24, 119, 242, 0.3)",
              "&:hover": {
                transform: "translateY(-4px) scale(1.15)",
                boxShadow: "0 12px 35px rgba(24, 119, 242, 0.5)",
              },
            }}
          >
            <a target="blank" href="https://www.facebook.com/share/1B6PEkwFS3/">
              <FacebookIcon
                sx={{ color: "white", fontSize: { xs: "20px", md: "24px" } }}
              />
            </a>
          </IconButton>

          <IconButton
            sx={{
              background:
                "linear-gradient(135deg, #e1306c 0%, #fd1d1d 50%, #fcb045 100%)",
              color: "white",
              width: { xs: "40px", md: "48px" },
              height: { xs: "40px", md: "48px" },
              transition: "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
              boxShadow: "0 4px 15px rgba(225, 48, 108, 0.3)",
              "&:hover": {
                transform: "translateY(-4px) scale(1.15)",
                boxShadow: "0 12px 35px rgba(225, 48, 108, 0.5)",
              },
            }}
          >
            <a
              target="blank"
              href="https://www.instagram.com/funingo.fun?igsh=eG01azR6ZGY2ZXEw"
            >
              <InstagramIcon
                sx={{ color: "white", fontSize: { xs: "20px", md: "24px" } }}
              />
            </a>
          </IconButton>

          <IconButton
            sx={{
              background: "linear-gradient(135deg, #ff0000 0%, #cc0000 100%)",
              color: "white",
              width: { xs: "40px", md: "48px" },
              height: { xs: "40px", md: "48px" },
              transition: "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
              boxShadow: "0 4px 15px rgba(255, 0, 0, 0.3)",
              "&:hover": {
                transform: "translateY(-4px) scale(1.15)",
                boxShadow: "0 12px 35px rgba(255, 0, 0, 0.5)",
              },
            }}
          >
            <a
              target="blank"
              href="https://youtube.com/@funingoadventurearena-0761?si=yy9N-RwCDKdStDgM"
            >
              <YouTubeIcon
                sx={{ color: "white", fontSize: { xs: "20px", md: "24px" } }}
              />
            </a>
          </IconButton>

          {/* LinkedIn - Hidden on mobile */}
          <IconButton
            sx={{
              display: { xs: "none", md: "inline-flex" },
              background: "linear-gradient(135deg, #0077b5 0%, #005885 100%)",
              color: "white",
              width: "48px",
              height: "48px",
              transition: "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
              boxShadow: "0 4px 15px rgba(0, 119, 181, 0.3)",
              "&:hover": {
                transform: "translateY(-4px) scale(1.15)",
                boxShadow: "0 12px 35px rgba(0, 119, 181, 0.5)",
              },
            }}
          >
            <a
              target="blank"
              href="https://www.linkedin.com/company/funingo-adventures/"
            >
              <LinkedInIcon sx={{ color: "white", fontSize: "24px" }} />
            </a>
          </IconButton>

          <IconButton
            sx={{
              background: "linear-gradient(135deg, #25d366 0%, #128c7e 100%)",
              color: "white",
              width: { xs: "40px", md: "48px" },
              height: { xs: "40px", md: "48px" },
              transition: "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
              boxShadow: "0 4px 15px rgba(37, 211, 102, 0.3)",
              "&:hover": {
                transform: "translateY(-4px) scale(1.15)",
                boxShadow: "0 12px 35px rgba(37, 211, 102, 0.5)",
              },
            }}
          >
            <a target="blank" href="https://maps.app.goo.gl/VL4sZnGMAWcG5nPd9">
              <LocationOnIcon
                sx={{ color: "white", fontSize: { xs: "20px", md: "24px" } }}
              />
            </a>
          </IconButton>
        </Box>

        <Divider
          orientation={{ xs: "horizontal", md: "vertical" }}
          sx={{
            mx: { xs: 0, md: "25px" },
            my: { xs: "10px", md: 0 },
            height: { xs: "2px", md: "40px" },
            width: { xs: "60px", md: "2px" },
            background:
              "linear-gradient(180deg, transparent, rgba(0,0,0,0.2), transparent)",
            border: "none",
          }}
        />

        <Typography
          sx={{
            cursor: "pointer",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: "700",
            fontSize: { xs: "16px", md: "18px" },
            position: "relative",
            transition: "all 0.3s ease",
            padding: { xs: "6px 12px", md: "8px 16px" },
            borderRadius: "8px",
            "&:hover": {
              transform: "translateY(-3px)",
              backgroundColor: "rgba(102, 126, 234, 0.1)",
            },
            "&:after": {
              content: '""',
              position: "absolute",
              bottom: "2px",
              left: "50%",
              width: "0%",
              height: "3px",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              transform: "translateX(-50%)",
              borderRadius: "2px",
              transition: "width 0.3s ease",
            },
            "&:hover:after": {
              width: "80%",
            },
          }}
          onClick={() => navigate("/careers")}
        >
          Careers
        </Typography>
      </Grid>

      <Divider
        sx={{
          borderWidth: "1px",
          width: "100%",
          background:
            "linear-gradient(90deg, transparent, rgba(0,0,0,0.1), transparent)",
          border: "none",
          height: "1px",
          mt: "30px",
        }}
      />

      <Grid
        mt="25px"
        sx={{
          textAlign: "center",
          padding: { xs: "20px 15px", md: "25px 30px" },
          borderRadius: "16px",
          background:
            "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
          border: "1px solid rgba(102, 126, 234, 0.15)",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 8px 30px rgba(102, 126, 234, 0.15)",
          },
        }}
      >
        <Typography
          sx={{
            fontWeight: "600",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontSize: { xs: "14px", md: "16px" },
            letterSpacing: "0.5px",
            mb: 1,
          }}
        >
          Developed and Maintained by
        </Typography>

        <Typography
          sx={{
            fontWeight: "400",
            color: "#666",
            fontSize: { xs: "12px", md: "13px" },
            letterSpacing: "0.3px",
            mb: 2,
          }}
        >
          Any concerns? Feel free to reach out
        </Typography>

        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={{ xs: 1.5, md: 2 }}
          flexWrap="wrap"
        >
          {/* LinkedIn Button */}
          <IconButton
            component="a"
            href="https://www.linkedin.com/in/gagan-shukla-972713228/"
            // href="https://www.linkedin.com/in/ayush-bhargava-a53a3a202/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              background: "linear-gradient(135deg, #0077b5 0%, #005885 100%)",
              color: "white",
              width: { xs: "42px", md: "48px" },
              height: { xs: "42px", md: "48px" },
              transition: "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
              boxShadow: "0 4px 15px rgba(0, 119, 181, 0.3)",
              "&:hover": {
                transform: "translateY(-4px) scale(1.15)",
                boxShadow: "0 12px 35px rgba(0, 119, 181, 0.5)",
              },
            }}
          >
            <LinkedInIcon
              sx={{ color: "white", fontSize: { xs: "22px", md: "24px" } }}
            />
          </IconButton>

          {/* Email Button */}
          <IconButton
            component="a"
            href="mailto:gagan.shuk@gmail.com"
            sx={{
              background: "linear-gradient(135deg, #ea4335 0%, #c5221f 100%)",
              color: "white",
              width: { xs: "42px", md: "48px" },
              height: { xs: "42px", md: "48px" },
              transition: "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
              boxShadow: "0 4px 15px rgba(234, 67, 53, 0.3)",
              "&:hover": {
                transform: "translateY(-4px) scale(1.15)",
                boxShadow: "0 12px 35px rgba(234, 67, 53, 0.5)",
              },
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={window.innerWidth < 768 ? "22" : "24"}
              height={window.innerWidth < 768 ? "22" : "24"}
              viewBox="0 0 24 24"
              fill="white"
            >
              <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
            </svg>
          </IconButton>
        </Box>
      </Grid>
      <Grid
        mt="20px"
        sx={{
          textAlign: "center",
          padding: "15px 25px",
          borderRadius: "12px",
          background:
            "linear-gradient(135deg, rgba(0,0,0,0.03) 0%, rgba(0,0,0,0.01) 100%)",
          border: "1px solid rgba(0,0,0,0.05)",
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "600",
            background: "linear-gradient(135deg, #555F68 0%, #333 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontSize: "14px",
            letterSpacing: "0.5px",
          }}
        >
          Copyright &nbsp;
          {/* &#169; */}
          2023 Funingo Limited | All rights reserved.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Footer;
